import { I18n } from '@aws-amplify/core';
import { message, notification } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import Api from '@/services/api';
import { BaseContext } from '@/types';
import { ROSA_QUERY_KEYS } from './query-keys';
import type { RosaRequiredEquipment } from '@/types/entities/Rosa';

type DeleteEquipmentRequest = BaseContext & {
	report_id: string;
	equipment_id: string;
};

type DeleteEquipmentResponse = RosaRequiredEquipment;

async function deleteEquipment(params: DeleteEquipmentRequest): Promise<DeleteEquipmentResponse> {
	const url = `/ergonomic-tool/rosa/equipments/${params.report_id}/${params.equipment_id}`;
	const { data } = await Api.delete(url, { params });
	return data;
}

export const useDeleteEquipment = () => {
	const queryClient = useQueryClient();
	return useMutation((params: DeleteEquipmentRequest) => deleteEquipment(params), {
		onError: (err: any) => {
			const typeError = err.response.data.details[0].split('" ');
			notification.error({
				message: I18n.get('Ops... something happened!'),
				description: I18n.get(typeError[1])
			});
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries([ROSA_QUERY_KEYS.GET_REQUIRED_EQUIPMENTS]);
			message.success(I18n.get('Element deleted successfully'));
		}
	});
};
